module.exports = __webpack_public_path__ + "static/media/right_arrow.aff3e449.svg";